export const apiUrls = {
  baseIdentityURL: 'https://identityapi.damavandclub.com/api',
  baseURL: 'https://userpanelapi.damavandclub.com/api',
  // baseURL: 'https://localhost:44368/api',
  // baseIdentityURL: 'http://localhost:5000/api',
}
